import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import ContactUS from './ContactUs';

interface ContactPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

const ContactPopup: React.FC<ContactPopupProps> = ({ isOpen, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            className="fixed inset-0 backdrop-blur-sm z-40 flex items-center justify-center overflow-y-auto py-4 px-2"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          >
            <motion.div
              className="relative bg-white rounded-3xl py-4 sm:py-6 px-4 sm:px-10 z-50 w-full max-w-3xl shadow-2xl border border-gray-100 mx-auto my-auto"
              initial={{ scale: 0.5, opacity: 0, y: 100 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.8, opacity: 0, y: 50 }}
              transition={{
                type: "spring",
                duration: 0.5,
                bounce: 0.3
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <ContactUS />
              
              <motion.button
                onClick={onClose}
                className="absolute top-2 sm:top-6 right-2 sm:right-6 text-gray-400 hover:text-gray-600 transition-colors z-[60] p-2"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                <svg className="w-6 sm:w-7 h-6 sm:h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </motion.button>
            </motion.div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default ContactPopup; 